import React, { createContext, useRef, useCallback } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';

const RECAPTCHA_SITE_KEY = process.env.NEXT_PUBLIC_RECAPTCHA_V2_SITE_KEY;

export const RecaptchaContext = createContext(null);

export function RecaptchaProvider({ children }) {
  const recaptchaRef = useRef(null);

  const execute = useCallback(async () => {
    if (!recaptchaRef.current) {
      throw new Error('reCAPTCHA not initialized');
    }

    const token = await recaptchaRef.current.executeAsync();
    recaptchaRef.current.reset();
    return token;
  }, []);

  const reset = useCallback(() => {
    recaptchaRef.current?.reset();
  }, []);

  return (
    <RecaptchaContext.Provider value={{ execute, reset }}>
      {children}
      <ReCAPTCHA
        ref={recaptchaRef}
        sitekey={RECAPTCHA_SITE_KEY}
        size="invisible"
        badge="bottomright"
      />
    </RecaptchaContext.Provider>
  );
}
